import {
  Component,
  Prop,
  h
} from '@stencil/core';
import map from 'lodash-es/map';
import moment from 'moment';
import { UtilityValue } from './utility-meter-interfaces';

@Component({
  tag: 'lar-utility-log',
  styleUrl: 'utility-log.scss',
  shadow: true
})
export class LogEntryList {
  @Prop() values: string = '[]';
  @Prop() measuringUnit: string = '';
  @Prop() webComponentValueType: string = '';

  render() {
    const values: UtilityValue[] = JSON.parse(this.values);
    const months = values && Array.isArray(values) ? values : [];
    let latestMonth = months.length > 0 ? months[0] : null;
    if (latestMonth && latestMonth.date !== moment().format('MM-YYYY')) {
      latestMonth = null;
    }
    const entries = map(months, (month, key) => {
      return {
        start: <lar-translate t={'date.months.' + (moment(month.date, 'MM-YYYY').month() + 1)} />,
        content: '',
        end: (
          <div>
            <small>{month.abs}</small>
            <small>{this.measuringUnit}</small> • <small>Δ</small> {month.rel}
            <small>{this.measuringUnit}</small>
          </div>
        ),
        group: moment(month.date, 'MM-YYYY').format('YYYY')
      };
    });
    const header = latestMonth ? (
      <div>
        <lar-list-item>
          <div slot="start">
            <strong><lar-translate t="utilityMeter.currentMonthReading" /></strong>
          </div>
          <div slot="end">
            <small>
              {latestMonth.abs}
              {this.measuringUnit}
            </small>
          </div>
        </lar-list-item>
        <lar-list-item>
          <div slot="start">
          <strong><lar-translate t="utilityMeter.currentMonthUsage" /></strong>
          </div>
          <div slot="end">
            <small>
              {latestMonth.rel}
              {this.measuringUnit}
            </small>
          </div>
        </lar-list-item>
      </div>
    ) : null;
    const groups = {};
    return (
      <lar-list>
        {header}
        {map(entries, entry => {
          // tslint:disable-next-line: no-shadowed-variable
          let header: any;
          if (!groups[entry.group]) {
            groups[entry.group] = entry.group;
            header = (
              <lar-list-header>
                {entry.group}
              </lar-list-header>
            );
          }
          return (
            <div>
              {header ? header : null}
              <lar-list-item>
                <div slot="start">{entry.start}</div>
                <div>{entry.content}</div>
                <div slot="end">{entry.end}</div>
              </lar-list-item>
            </div>
          );
        })}
      </lar-list>
    );
  }
}
